/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { tinycolor } from '../vendor/tinycolor.js';


export let MDUsers = function() {

	function getUsersBGColor( users_hue, which ) {
		if( which==='annotations1' )      return tinycolor( { h:users_hue, s:20, v:98 } );
		else if( which==='annotations2' ) return tinycolor( { h:users_hue, s:15, v:92 } );
		// default for everything else
		return tinycolor( { h:users_hue, s:80, v:75 } );
	}
	function getUsersFGColor( users_hue, which ) {
		var bg = getUsersBGColor(users_hue,which),
			fgcandidates = bg.splitcomplement();
		return tinycolor.mostReadable(bg,fgcandidates,{includeFallbackColors:true});
	}
	function getUsersColorCSS( users_hue, which ) {
		return {
			backgroundColor: getUsersBGColor(users_hue,which).toHexString(),
			color: getUsersFGColor(users_hue,which).toHexString()
		};
	}

	return {
		getUsersBGColor: getUsersBGColor,
		getUsersFGColor: getUsersFGColor,
		getUsersColorCSS: getUsersColorCSS,
	};
}(); // namespace MDUsers

